import { UploadItem } from '@wellesley/uploads'
import { UploadPreviewItem } from './UploadPreviewItem'
import { useUploadTracking } from './useUploadTracking'

type UploadingViewProps = {
  uploadingItems: UploadItem[]
  onComplete: (completedItems: UploadItem[]) => void
  onAllCanceled: () => void
}

export const UploadingView = ({
  uploadingItems,
  onComplete,
  onAllCanceled,
}: UploadingViewProps) => {
  const { isItemCompleted, isItemError } = useUploadTracking({
    uploadingItems,
    onComplete,
    onAllCanceled,
  })

  return (
    <div className="p-s">
      <div className="mb-s text-sm font-medium text-gray-700">
        Uploading files...
      </div>
      <div className="flex flex-wrap gap-2">
        {uploadingItems.map((item) => (
          <UploadPreviewItem
            key={item.id}
            item={item}
            isCompleted={isItemCompleted(item.id)}
            isError={isItemError(item.id)}
          />
        ))}
      </div>
    </div>
  )
}
